module.exports = __webpack_public_path__ + "img/40_00_079_473.85d61f5a.jpg";